export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBVT6N0c7UQ0oDAp3UIaVy0Li4gDlS19DA',
    authDomain: 'supedidosas-c27a2.firebaseapp.com',
    projectId: 'supedidosas-c27a2',
    storageBucket: 'supedidosas-c27a2.appspot.com',
    messagingSenderId: '285731438091',
    appId: '1:285731438091:web:c7f094114ef126e2ed910e',
    measurementId: 'G-HZQT9XD7Q0'
  }
};
